import store from 'containers/store'
import { Map } from 'immutable'
import { orgId as fetchOrgId } from 'app/modules/org/selectors'
import { LINKEDIN_KEY } from 'constants/ResourcesConstants'

const getAllIntegrations = () => {
  return store.getState().getIn(['integrations', 'connections'], Map())
}

const isIntegrationConnected = integration => {
  const integrationStatuses = store.getState().getIn(['integrations', 'connections'], Map())
  return !!integrationStatuses[integration]
}

const getLinkedinIFrameUrl = (endUser, name, website) => {
  let profile
  endUser = endUser || {}
  if (endUser) {
    profile = 'lead'
  } else {
    profile = 'account'
  }

  const email = _.get(endUser, 'email', '')
  const firstName = _.get(endUser, 'firstName', '')
  const lastName = _.get(endUser, 'lastName', '')

  const orgId = fetchOrgId(store.getState())

  return `https://www.linkedin.com/sales/widget/profile-matching?
  apiKey=${LINKEDIN_KEY}&
  profile=${profile}&
  firstName=${firstName}&
  lastName=${lastName}&
  email=${email}&
  companyName=${name || ''}&
  companyWebsite=${website || ''}&
  crmRecordId=ddccbbAA&
  crmOrgId=${orgId}&
  crmSourceType=PARTNER&
  modules=TopCard2,RelatedLeads&
  version=2.0.0&
  isInlineMode=true`
}

export { getLinkedinIFrameUrl, isIntegrationConnected, getAllIntegrations }


// WEBPACK FOOTER //
// ./src/scripts/utils/Integrations.js